export default __webpack_public_path__ + "static/media/ci_202209.55f92b74.png";